import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from '../../../components/modal/Modal';
import { VerifyLawyerModalContent } from '../components/VerifyLawyerModalComponents';
import { BrandSecondaryButton } from '../../../components/button';
import { RestrictedModalLayout } from '../../../components/modal/components/modal-restricted/RestrictedModalLayout';
import styles from './verify_lawyer_modal_validated.module.scss';

type Props = { closeModal: () => void; isOpen: boolean };

export const VerifyLawyerModalValidated: FC<Props> = ({
  closeModal,
  isOpen,
}) => (
  <Modal isOpen={isOpen} onRequestClose={closeModal}>
    <RestrictedModalLayout
      closeModal={closeModal}
      source="verify-lawyer-modal-validated"
    >
      <img src="/img/icons/verify.png" alt="verify-icon" />
      <div className="restricted-modal__title">
        <FormattedMessage id="entity/expertises/VerifyLawyerModalValidated.tsx/1" />
      </div>
      <VerifyLawyerModalContent>
        <span className={styles.text}>
          <FormattedMessage id="entity/expertises/VerifyLawyerModalValidated.tsx/2" />
        </span>
      </VerifyLawyerModalContent>
      <div className={styles.button}>
        <BrandSecondaryButton onClick={closeModal}>
          <FormattedMessage id="entity/expertises/VerifyLawyerModalValidated.tsx/3" />
        </BrandSecondaryButton>
      </div>
    </RestrictedModalLayout>
  </Modal>
);
